import { configureStore } from '@reduxjs/toolkit'
import GuardStore from './auth_slice/guard'
import ModelStore from './model_slice/model'
import library from './library_slice/index'

export const store = configureStore({
    reducer: {
        guard: GuardStore,
        library: library,
        model: ModelStore
    },
    middleware:getDefaultMiddleware => getDefaultMiddleware({
        // 关闭redux序列化检测
        serializableCheck:false
    })
})

// 从 store 本身推断出 `RootState` 和 `AppDispatch` 类型
export type RootState = ReturnType<typeof store.getState>
// 推断出类型: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
